import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import {
  AUDIO_PLAYER_HEIGHT,
  FLASH_SALE_BANNER_HEIGHT,
  MOBILE_BREAKPOINT,
  TITLE_PRODUCT_HEIGHT,
} from '@src/styles/config';

const StyledContent = styled('div')`
  position: relative;
  padding-top: 8px;

  .loading-load-request {
    color: ${COLOR.loadingLoadRequest};
  }

  .cursor-not-allowed {
    cursor: not-allowed;
  }

  .preview-guide {
    @media (max-width: 1000px) {
      display: none;
    }

    @media (min-width: 1000px) {
      display: flex;
    }

    position: absolute;
    font-size: 14px;
    bottom: ${(props) =>
      props.showSample && !props.openSentences ? '42px' : '-8px'};

    display: flex;
    justify-content: center;
    align-items: center;
    left: 50%;
    transform: translate(-50%);
    z-index: 1024;
    gap: 12px;

    .change-size-editor {
      border: 1px solid ${COLOR.secondary[32]};
      text-transform: none;
      padding: 2px 10px;
      border-radius: 20px;
      background: ${COLOR.white};
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2px;
      color: ${COLOR.darkBlue};
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        background: ${COLOR.charcoal};
      }
    }

    .expand-icon {
      margin-left: -8px;
    }
  }
  .preview-guide-new-ui {
    bottom: ${(props) =>
      props.showSample && !props.openSentences ? '42px' : '-27px'};
    .new-preview-guide-btn {
      width: 48px;
      box-sizing: border-box;
      background-color: white;
      opacity: 1;
      border-radius: 500px;
      padding: 11px;
      display: grid;
      place-content: center;
      &:hover {
        opacity: 1;
        background-color: #f8f8f8;
      }
    }
  }
  .editor-wrapper-new-layout {
    height: ${(props) =>
      props.requestTableHeight
        ? `calc(100vh - ${TITLE_PRODUCT_HEIGHT}px - 61px - ${
            props.requestTableHeight
          }px - ${props.showaudioplayer ? AUDIO_PLAYER_HEIGHT : 0}px + ${
            !props.useNewTTSLayout ? 13 : 0
          }px - ${props.headerVoucher ? FLASH_SALE_BANNER_HEIGHT : 0}px + 50px)`
        : `calc(100vh - ${TITLE_PRODUCT_HEIGHT}px - 61px - 320px - ${
            props.showaudioplayer ? AUDIO_PLAYER_HEIGHT : 0
          }px - ${props.headerVoucher ? FLASH_SALE_BANNER_HEIGHT : 0}px)`};
    overflow-y: auto;
    overflow-x: hidden;

    // scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }

    a:-webkit-any-link {
      color: ${COLOR.blue};
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .editor-wrapper {
    height: ${(props) =>
      props.requestTableHeight
        ? `calc(100vh - ${TITLE_PRODUCT_HEIGHT}px - 32px -  ${
            props.requestTableHeight
          }px - ${props.showaudioplayer ? AUDIO_PLAYER_HEIGHT : 0}px - ${
            props.useHeaderBanner && props.headerVoucher
              ? FLASH_SALE_BANNER_HEIGHT
              : 0
          }px)`
        : `calc(100vh - ${TITLE_PRODUCT_HEIGHT}px - 32px - 320px - ${
            props.showaudioplayer ? AUDIO_PLAYER_HEIGHT : 0
          }px - ${
            props.useHeaderBanner && props.headerVoucher
              ? FLASH_SALE_BANNER_HEIGHT
              : 0
          }px)`};
    overflow-y: auto;
    overflow-x: hidden;

    // scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }

    a:-webkit-any-link {
      color: ${COLOR.blue};
      cursor: pointer;
      text-decoration: underline;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .editor-wrapper {
      height: ${(props) =>
        props.requestTableHeight
          ? `calc(100vh - 25px -  ${props.requestTableHeight}px)`
          : `calc(100vh - 25px - 320px - ${
              props.showaudioplayer ? AUDIO_PLAYER_HEIGHT : 0
            }px)`};
    }
  }

  .character-exceed {
    color: ${COLOR.danger};
  }
  .DraftEditor-root {
    height: 90%;
    font-family: 'SF Pro Text', sans-serif;
    font-size: 16px;
    line-height: 1.5;
  }

  .search-highlight {
    color: ${COLOR.darkBlue};
    background-color: ${COLOR.primary};
  }

  .black-word-highlight {
    color: ${COLOR.darkBlue};
    background-color: ${COLOR.error};
  }
`;

const StyledSentenceItem = styled('div')`
  position: relative;
  .block-wrapper {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    cursor: not-allowed;
  }

  .check-box {
    padding: 0;
    color: ${COLOR.darkBlue};
  }

  .voice-info {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }

  .editor-container {
    flex: 1;
    font-size: 14px;
  }
  .character-exceed {
    color: ${COLOR.danger};
  }

  .sentence-toolbar {
    display: flex;
    align-items: center;
    width: fit-content;
  }

  @media only screen and (min-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${COLOR.divider};
    padding: 3px 0;

    .play-audio {
      margin: 0 10px;
    }

    .voice-info {
      margin-left: 15px;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    border-bottom: 1px solid ${COLOR.divider};

    .editor-container {
      margin-top: 10px;
      margin-left: 10px;
    }
  }
`;

const StyledSentences = styled('div')`
  height: ${(props) =>
    props.requestTableHeight
      ? `calc(100vh + ${
          props.openSentences && !props.headerVoucher ? 7 : 0
        }px - 156px - ${props.requestTableHeight}px + ${
          !props.useNewTTSLayout ? 56 : 0
        }px - ${props.showaudioplayer ? AUDIO_PLAYER_HEIGHT : 0}px - ${
          props.headerVoucher ? FLASH_SALE_BANNER_HEIGHT : 0
        }px + ${props.headerVoucher ? 7 : 0}px - ${
          !props.useNewTTSLayout ? 5 : 0
        }px + 34px)`
      : `calc(100vh - 156px + ${!props.useNewTTSLayout ? 56 : 0}px - 320px  - ${
          props.showaudioplayer ? AUDIO_PLAYER_HEIGHT : 0
        }px)`};
  overflow-y: auto;

  // scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${COLOR.white};
  }
  &::-webkit-scrollbar-thumb {
    background: ${COLOR.indigo[64]};
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${COLOR.indigo[80]};
    border-radius: 100px;
  }

  a:-webkit-any-link {
    color: ${COLOR.blue};
    cursor: pointer;
    text-decoration: underline;
  }

  .check-box-all {
    padding: 10px;
  }

  .sentence-header {
    display: flex;
    align-items: center;
    position: relative;

    .block-wrapper {
      position: absolute;
      z-index: 10;
      width: 100%;
      height: 100%;
      cursor: not-allowed;
    }
  }

  .checkbox-color {
    color: ${COLOR.darkBlue};
  }

  .delete-sentence {
    display: flex;
    align-items: center;
    color: ${COLOR.danger};
    cursor: pointer;
  }
`;

const StyledChangeBoxTtsSizeButton = styled('div')`
  display: flex;
  align-items: top;
  justify-content: center;
  position: relative;

  .line {
    width: 100%;
    height: 1px;
    background-color: ${COLOR.light};
  }

  .button {
    position: relative;
    display: flex;
    justify-content: center;
    width: 180px;
    margin-top: -1px;

    .size {
      width: 180px;
    }

    .button-content {
      cursor: pointer;
      position: absolute;
      margin-left: -1px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      z-index: 30;
      color: ${COLOR.darkBlue};
      font-weight: 600;
      font-size: 14px;
      transform: rotateX(4deg) !important;
    }
  }
`;

const StyledPreviewButton = styled(Paper)`
  border-radius: 100%;
  width: 34px;
  height: 34px;
  border: 1px solid ${COLOR.subText};
  display: flex;
  align-items: center;
  justify-content: center;
  over-flow: hidden;
  &:hover {
    border: 1px solid ${COLOR.primary};
  }
`;

const StyledConvertAction = styled('div')`
  position: absolute;
  right: 0px;
  bottom: -10px;
  z-index: 100;
  border-radius: 12px;

  .custom-button {
    text-transform: none;
    border-radius: 12px;
    padding: 4px 6px;
    min-width: fit-content;
    color: ${(props) =>
      props.disabled ? COLOR.disableButton : COLOR.darkBlue};

    &:hover,
    &:focus {
      background: ${COLOR.secondary[80]};
    }
  }
`;

const StyledActionReset = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  .button {
    display: flex;
    height: 28px;
    padding: 0px 12px;
    width: 70px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 500px;
    text-transform: none;
  }
  .outlined-button {
    border: 1px solid ${COLOR.indigo[32]};
  }
`;

const StyledPreviewGuide = styled('div')`
  display: inline-flex;
  padding: 6px 12px;
  align-items: flex-end;
  gap: 8px;
  border-radius: 12px;
  background: ${COLOR.grayV2[100]};

  .description {
    color: ${COLOR.secondary[8]};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .ignore-text {
    font-size: 14px;
    font-style: normal;
    font-weight: 510;
    line-height: 20px;
    letter-spacing: -0.4px;
    text-decoration-line: underline;
    cursor: pointer;
  }
`;

const StyledPreviewButtonNew = styled('div')`
  .ai-editor-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .tool-row {
    display: flex;
    height: 38px;
    padding-top: 16px;
    border-radius: 8px;
    width: 100%;
    justify-content: space-between;
    align-items: flex-end;
  }
`;

const StyledSentencesHeader = styled('div')`
  a:-webkit-any-link {
    color: ${COLOR.blue};
    cursor: pointer;
    text-decoration: underline;
  }

  .check-box-all {
    padding: 10px;
  }

  .sentence-header {
    display: flex;
    align-items: center;
    position: relative;
    background-color: ${COLOR.white};
  }

  .checkbox-color {
    color: ${COLOR.darkBlue};
  }

  .delete-sentence {
    display: flex;
    align-items: center;
    color: ${COLOR.danger};
    cursor: pointer;
  }
`;

const StyledStudioExperienceBanner = styled('div')`
  padding: 12px;
  gap: 16px;
  display: flex;
  border: 1px solid #3c3c4329;
  background-color: #ffffff;
  z-index: 1000;
  border-radius: 16px;
  position: absolute;
  bottom: 67px;
  justify-content: space-between;
  width: 98%;
  .close-icon-container {
    display: flex;
    align-items: center;
    .close-icon {
      cursor: pointer;
      color: #1e164ea3;
    }
  }

  .studio-experience-banner-content {
    margin-top: 5px;
    .studio-experience-banner-content-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.4px;
      color: #000000;
      margin-bottom: 8px;
    }
    .studio-experience-banner-content-description {
      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        color: #1c1c1ea3;
      }
    }
  }

  .studio-experience-banner-content-button-container {
    display: flex;
    align-items: center;
    gap: 8px;

    .button-gradient {
      padding: 8px 12px;
      position: relative;
      width: max-content;
      background: transparent;
      cursor: pointer;
      border: none;
      color: transparent;
      height: 40px;
      box-sizing: border-box;
      background-clip: text;
      -webkit-background-clip: text;
      background-image: linear-gradient(90deg, #ff6a6a, #8f6aff);
      -webkit-text-fill-color: transparent;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      text-align: center;
      vertical-align: middle;

      &:before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 12px;
        padding: 2px;
        border: 1px solid #3c3c4329;
      }
      &:hover {
        &:before {
          background: ${TRANSPARENT_COLOR.dark};
        }
      }
    }
  }
`;

const StyledEditorWithSidebar = styled('div')`
  display: flex;
  gap: 16px;

  .editor-flex-area {
    flex: 1;
    min-width: 0;
    position: relative;
  }
`;

export {
  StyledContent,
  StyledSentenceItem,
  StyledSentences,
  StyledSentencesHeader,
  StyledChangeBoxTtsSizeButton,
  StyledPreviewButton,
  StyledConvertAction,
  StyledActionReset,
  StyledPreviewGuide,
  StyledPreviewButtonNew,
  StyledStudioExperienceBanner,
  StyledEditorWithSidebar,
};
